module.exports = __webpack_public_path__ + "img/map_11.4d8e7c67.webp";